class QuantitySelector extends HTMLElement {
  constructor() {
    super();
    this.quantity = 1;
    this.min = 1;
    this.max = null;
  }

  connectedCallback() {
    this.quantity = parseInt(this.getAttribute('value') || '1', 10);
    this.min = parseInt(this.getAttribute('min') || '1', 10);
    const maxAttr = this.getAttribute('max');
    this.max = maxAttr ? parseInt(maxAttr, 10) : null;

    this.render();
    this.attachEventListeners();
  }

  static get observedAttributes() {
    return ['value', 'min', 'max'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue !== newValue) {
      if (name === 'value') {
        this.quantity = parseInt(newValue || '1', 10);
        this.updateInput();
      } else if (name === 'min') {
        this.min = parseInt(newValue || '1', 10);
      } else if (name === 'max') {
        this.max = newValue ? parseInt(newValue, 10) : null;
      }
    }
  }

  render() {
    this.innerHTML = `
      <div class="shpgrs-input-counter shpgrs-input-counter-style-01">
        <span class="shpgrs-minus-btn" role="button" tabindex="0" aria-label="Decrementar cantidad"></span>
        <input
          type="text"
          name="quantity"
          value="${this.quantity}"
          min="${this.min}"
          ${this.max ? `max="${this.max}"` : ''}
          size="100"
          class="shpgrs-quantity-input"
          aria-label="Cantidad"
        >
        <span class="shpgrs-plus-btn" role="button" tabindex="0" aria-label="Incrementar cantidad"></span>
      </div>
    `;
  }

  attachEventListeners() {
    const minusBtn = this.querySelector('.shpgrs-minus-btn');
    const plusBtn = this.querySelector('.shpgrs-plus-btn');
    const input = this.querySelector('input');

    // Event listeners para los botones
    minusBtn.addEventListener('click', () => this.decrement());
    plusBtn.addEventListener('click', () => this.increment());

    // Soporte para teclado (accesibilidad)
    minusBtn.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.decrement();
      }
    });

    plusBtn.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.increment();
      }
    });

    // Validar cuando el usuario escribe directamente en el input
    input.addEventListener('change', () => {
      const newValue = parseInt(input.value, 10);
      if (!isNaN(newValue)) {
        this.setQuantity(newValue);
      } else {
        this.setQuantity(this.min);
      }
    });

    input.addEventListener('blur', () => {
      const newValue = parseInt(input.value, 10);
      if (isNaN(newValue) || newValue < this.min) {
        this.setQuantity(this.min);
      } else if (this.max && newValue > this.max) {
        this.setQuantity(this.max);
      }
    });
  }

  decrement() {
    if (this.quantity > this.min) {
      this.setQuantity(this.quantity - 1);
    }
  }

  increment() {
    if (!this.max || this.quantity < this.max) {
      this.setQuantity(this.quantity + 1);
    }
  }

  setQuantity(newQuantity) {
    // Asegurar que la cantidad esté dentro de los límites
    if (newQuantity < this.min) {
      newQuantity = this.min;
    }
    if (this.max && newQuantity > this.max) {
      newQuantity = this.max;
    }

    this.quantity = newQuantity;
    this.setAttribute('value', newQuantity);
    this.updateInput();

    // Dispatch evento personalizado para que otros scripts puedan escuchar
    this.dispatchEvent(new CustomEvent('quantity-change', {
      detail: { quantity: this.quantity },
      bubbles: true
    }));
  }

  updateInput() {
    const input = this.querySelector('input');
    if (input) {
      input.value = this.quantity;
      // También disparar evento change en el input para compatibilidad
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  getValue() {
    return this.quantity;
  }
}

// Registrar el web component
if (!customElements.get('quantity-selector')) {
  customElements.define('quantity-selector', QuantitySelector);
}

